/*
    There currently is a Toolkit V2 Price component. It's highly used throughout the site at the moment and differents vastly from the new UI.
    When all cards are migrated, consider using this card as the Toolkit V2 Price component.
*/

import * as Styled from '../../../components/AdCard/Price/Price.styled';
import type { PriceProps } from '../../../components/AdCard/Price/Price.typed';
import { getPriceDisplay } from '../../../helpers/getPriceDisplay';

const Price = (props: PriceProps) => {
  const {
    financePPM,
    previousPrice,
    price,
    priceOnRequest,
    isGrid,
    pricingIndicatorSlot,
  } = props;

  const { priceText, isValidPrice } = getPriceDisplay({
    price,
    priceOnRequest: priceOnRequest ?? false,
    currency: null,
  });

  return (
    <Styled.Wrapper>
      {previousPrice && <Styled.OldPrice>{previousPrice}</Styled.OldPrice>}

      <Styled.PriceContainer isGrid={isGrid}>
        <Styled.PriceRow isGrid={isGrid}>
          <Styled.Price isValidPrice={isValidPrice} isGrid={isGrid}>
            {priceText}
          </Styled.Price>
          {pricingIndicatorSlot}
        </Styled.PriceRow>

        {financePPM && (
          <Styled.PricePerMonth isGrid={isGrid}>
            {financePPM}
          </Styled.PricePerMonth>
        )}
      </Styled.PriceContainer>
    </Styled.Wrapper>
  );
};

export default Price;
